module.exports = __webpack_public_path__ + "img/Egypt.100f1ba6.svg";